import styled from 'styled-components';
import * as Shared from '../components/shared.styles';

export const PageWrapper = Shared.PageWrapper;
export const Navbar = Shared.Navbar;
export const NavContent = Shared.NavContent;
export const Logo = Shared.Logo;
export const ThemeToggleButton = Shared.ThemeToggleButton;
export const LightModeIcon = Shared.LightModeIcon;
export const DarkModeIcon = Shared.DarkModeIcon;
export const AcknowledgementSection = Shared.AcknowledgementSection;
export const AcknowledgementText = Shared.AcknowledgementText;
export const AcknowledgementImage = Shared.AcknowledgementImage;
export const Footer = Shared.Footer;
export const FooterContent = Shared.FooterContent;
export const FooterText = Shared.FooterText;
export const FooterLink = Shared.FooterLink;
export const FooterLinks = Shared.FooterLinks;
export const SocialLinks = Shared.SocialLinks;
export const SocialIcon = Shared.SocialIcon;
export const FooterWrapper = Shared.FooterWrapper;
export const FooterLeftSection = Shared.FooterLeftSection;
export const AcknowledgementFooterText = Shared.AcknowledgementFooterText;
export const FooterCopyright = Shared.FooterCopyright;
export const FooterPolicies = Shared.FooterPolicies;
export const FooterCenterSection = Shared.FooterCenterSection;
export const FooterRightSection = Shared.FooterRightSection;
export const FlagsContainer = Shared.FlagsContainer;
export const FlagImage = Shared.FlagImage;
export const AppStoresContainer = Shared.AppStoresContainer;
export const SignInButton = Shared.SignInButton;

export const HeaderSection = styled.div`
  width: 100%;
  height: 200px;
  padding: ${({ theme }) => theme.landingSpacing.xl} 0;
  background: linear-gradient(
    to bottom right,
    ${({ theme }) => theme.landing.gradientFrom},
    ${({ theme }) => theme.landing.gradientVia},
    ${({ theme }) => theme.landing.gradientTo}
  );
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderContent = styled.div`
  text-align: center;
  text-transform: capitalize;
`;

export const HeaderTitle = styled.h1`
  font-size: 2.25rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  color: ${({ theme }) => theme.landing.text};
  line-height: 1.2;
`;

export const ContentSection = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.landingSpacing.xl} ${({ theme }) => theme.landingSpacing.sm};
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.landing.background};
  color: ${({ theme }) => theme.landing.textSecondary};
  transition: all 0.3s ease;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.xxxl} ${({ theme }) => theme.landingSpacing.xxxl};
  }

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: 5rem 12.5rem;
  }
`;

export const ContentBlock = styled.div`
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LastUpdated = styled.p`
  font-style: italic;
  color: ${({ theme }) => theme.landing.footerText};
  line-height: 1.6;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.landing.text};
  margin-bottom: ${({ theme }) => theme.landingSpacing.sm};
`;

export const SectionParagraph = styled.p`
  font-style: italic;
  color: ${({ theme }) => theme.landing.footerText};
  line-height: 1.6;
  margin-bottom: ${({ theme }) => theme.landingSpacing.sm};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const List = styled.ul`
  color: ${({ theme }) => theme.landing.footerText};
  list-style-type: disc;
  list-style-position: inside;
  margin: ${({ theme }) => theme.landingSpacing.sm} 0;

  li {
    margin-bottom: ${({ theme }) => theme.landingSpacing.xs};
  }
`;

export const ContactInfo = styled.div`
  font-style: italic;
  color: ${({ theme }) => theme.landing.footerText};
  line-height: 1.6;

  div {
    margin-bottom: ${({ theme }) => theme.landingSpacing.xs};
  }
`;
